import AuthAxios from "./authAxios";


export const getInvite = async(id) => {
    const response = await AuthAxios.get(`requirement/${id}/invite?sort=createdAt:desc`);
    return response?.data;
}

export const addPayment = async() => {
    const response = await AuthAxios.get(`transaction/payment-methods`);
    return response?.data;
}

export const createTransaction = async(request) => {
    const response = await AuthAxios.post(`transaction/card-details`, {});
    return response?.data;
}

export const enrollBatch = async(batchID) => {
    const response = await AuthAxios.put(`batch/${batchID}/enroll`);
    return response?.data;
}

export const getBatchList = async(url) => {
    const response = await AuthAxios.get(url);
    return response?.data;
}

export const getAllCategory = async() => {
    const response = await AuthAxios.get('cms/category');
    return response?.data;
}

export const addFavorite = async(request) => {
    const response = await AuthAxios.put('batch/favorite', request);
    return response?.data;
}

export const requirementList = async() => {
    const response = await AuthAxios.get('requirement/search?sort=createdAt:desc&page=1&limit=100');
    return response?.data;
}

export const createdRequirementList = async() => {
    const response = await AuthAxios.get('requirement/my-created?status=ONGOING&sort=createdAt:desc');
    return response?.data;
}

export const batches = async(url, params) => {
    const response = await AuthAxios.get(url, params);
    return response?.data;
}

export const googleSignUp = async(url, params) => {
    const response = await AuthAxios.post(url, params);
    console.log(url, params, response)
    return response;
}

export const getBatchDetail = async(id) => {
    const response = await AuthAxios.get(`batch/${id}`);
    return response?.data;
}

export const studentAttendance = async(params) => {
    const response = await AuthAxios.get(`batch/${params.batchID}/${params.userId}/attendance-student?date=2025-07-16&range=month`);
    return response?.data;
}

export const enrolledStudentList = async(params) => {
    const response = await AuthAxios.get(`batch/${params.batchID}/${params.userId}/attendance-student?date=${params.date}&range=${params.range}`);
    return response?.data;
}

export const updateAttendance = async(params) => {
    const response = await AuthAxios.put(`batch/${params.batchID}/attendance`, params.request);
    console.log(response);
    return response?.data;
}

export const enrolledStudentsDetail = async(params) => {
    const response = await AuthAxios.get(`batch/${params.batchID}/enrolled`);
    return response?.data;
}

export const upload = async(file) => {
    const response = await AuthAxios.post('upload', file);
    return response?.data;
}

export const uploadProfileImage = async(file) => {
    const response = await AuthAxios.post('upload/profile-image', file);
    return response?.data;
}

export const videoVerification = async(file) => {
    const response = await AuthAxios.post('upload/video-verification', file);
    return response?.data;
}

export const userProfile = async(userId) => {
    const response = await AuthAxios.get(`users/${userId}/details`);
    return response?.data;
}

export const profileReviews = async(batchId) => {
    const response = await AuthAxios.get(`batch/${batchId}/review`);
    return response?.data;
}

export const getBankStatus = async() => {
    const response = await AuthAxios.get('transaction/bank-status');
    return response?.data;
}

export const setupBank = async() => {
    const response = await AuthAxios.post('transaction/setup-bank');
    return response?.data;
}

export const addReview = async(params) => {
    const response = await AuthAxios.post(`batch/${params.batchId}/review`, params.request);
    return response?.data;
}

// export const verifyUser = async(params) => {
//     const response = await AuthAxios.post('auth/criminal-verification', params);
//     return response?.data;
// }


export const verifyUser = async(params) => {

    const response = await AuthAxios.post('https://data.searchbug.com/api/search.aspx', params);
    return response?.data;
}

export const getCategoryList = async() => {
    const response = await AuthAxios.get('cms/category');
    return response?.data;
}

export const verifyOtp = async(request) => {
    const response = await AuthAxios.post('auth/verify-otp', request);
    return response?.data;
}

export const pauseBatch = async(batchID, request) => {
    const response = await AuthAxios.put(`batch/${batchID}/pause`, request);
    return response?.data;
}

export const endBatch = async(batchID) => {
    const response = await AuthAxios.put(`batch/${batchID}/end`);
    return response?.data;
}

export const resendOtp = async(request) => {
    const response = await AuthAxios.post(`auth/resend-otp`, request);
    return response?.data;
}

export const availableBatchesByUser = async(userId) => {
    const response = await AuthAxios.get(`batch/search?sort=enrollmentCount:desc&page=1&limit=10&createdBy=${userId}`);
    return response?.data;
}

export const linkedInLogin = async(request) => {
    const response = await AuthAxios.get('auth/linkedin/login');
    return response;
}

// export const getBatchLocation = async() => {
//     const response = await AuthAxios.get('batch/locations');
//     return response;
// }

export const getBatchLocation = async() => {
    const response = await AuthAxios.get('batch/filters-location');
    return response;
}